import React from 'react';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

const MaintenanceServiceSheet = ({ maintenance, nextProtocolNumber }) => {
  // Usa il protocollo della manutenzione se esiste, altrimenti usa nextProtocolNumber
  const protocolToShow = maintenance?.protocolNumber || nextProtocolNumber;
  
  return (
    <div id="service-sheet" style={{
      position: 'relative',
      width: '90mm',
      height: '205mm',
      margin: 0,
      padding: 0,
      fontFamily: 'Arial, sans-serif',
      fontSize: '12pt',
      lineHeight: '1',
      boxSizing: 'border-box',
      pageBreakAfter: 'avoid',
      pageBreakBefore: 'avoid',
      pageBreakInside: 'avoid'
    }}>
      {/* Ricevuta N. */}
      <div style={{ position: 'absolute', top: '60mm', left: '30mm' }}>
        {protocolToShow}
      </div>

      {/* Nominativo */}
      <div style={{ position: 'absolute', top: '68mm', left: '30mm' }}>
        {maintenance?.customerName || ''}
      </div>

      {/* Telefono */}
      <div style={{ position: 'absolute', top: '76mm', left: '30mm' }}>
        {maintenance?.customerPhone || ''}
      </div>

      {/* Data */}
      <div style={{ position: 'absolute', top: '84mm', left: '30mm' }}>
        {format(new Date(), 'dd/MM/yyyy', { locale: it })}
      </div>

      {/* Modello */}
      <div style={{ position: 'absolute', top: '92mm', left: '30mm' }}>
        {maintenance?.bikeBrand} {maintenance?.bikeModel}
      </div>

      {/* Anomalia / Lavori da effettuare */}
      <div style={{ position: 'absolute', top: '108mm', left: '10mm', width: '80mm', whiteSpace: 'pre-wrap', lineHeight: '1.7' }}>
        {maintenance?.description || ''}
      </div>

      {/* Sezione tagliando sotto */}
      {/* Data tagliando */}
      <div style={{ position: 'absolute', top: '163mm', left: '40mm' }}>
        {format(new Date(), 'dd/MM/yyyy', { locale: it })}
      </div>

      {/* Ricevuta N. sotto */}
      <div style={{ position: 'absolute', top: '170mm', left: '40mm' }}>
        {protocolToShow}
      </div>

      {/* Acconto */}
      <div style={{ position: 'absolute', top: '170mm', left: '71mm' }}>
        {maintenance?.deposit ? `€${parseFloat(maintenance.deposit).toFixed(2)}` : '€0,00'}
      </div>

      {/* Stile stampa */}
      <style>
        {`
          @page {
            size: 90mm 205mm;
            margin: 0;
            padding: 0;
          }
          @media print {
            html, body {
              width: 90mm;
              height: 205mm;
              margin: 0;
              padding: 0;
            }
            body * {
              visibility: hidden;
            }
            #service-sheet, #service-sheet * {
              visibility: visible;
            }
            #service-sheet {
              position: fixed;
              top: 0;
              left: 0;
              width: 90mm !important;
              height: 205mm !important;
              margin: 0 !important;
              padding: 0 !important;
              overflow: hidden !important;
              page-break-after: avoid !important;
              page-break-before: avoid !important;
              page-break-inside: avoid !important;
            }
            /* Nascondi tutte le altre pagine */
            #root > *:not(#service-sheet) {
              display: none !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default MaintenanceServiceSheet;
